/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nolisting1Inputs */

const en_nolisting1 = /** @type {(inputs: Nolisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listing (standalone event)`)
};

const de_nolisting1 = /** @type {(inputs: Nolisting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ort (eigenständiges Event)`)
};

/**
* | output |
* | --- |
* | "No listing (standalone event)" |
*
* @param {Nolisting1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nolisting1 = /** @type {((inputs?: Nolisting1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nolisting1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nolisting1(inputs)
	return de_nolisting1(inputs)
});
export { nolisting1 as "noListing" }